var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.banners.length > 0)?_c('BannerSwiper',{attrs:{"banners":_vm.banners,"showSearch":true,"showNavigation":false,"showPagination":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }